const locales = {
  c4r: {
    form: {
      selectAll: 'Select all',
      selectNone: 'None',
      allSelected: 'All selected',
      noneSelected: 'None selected',
      selected: 'selected',
      add: 'Add'
    },
    widgets: {
      category: {
        apply: 'Terapkan',
        unlock: 'Buka kunci',
        lock: 'Kunci',
        clear: 'Bersihkan',
        noResults: 'Tidak ada hasil',
        noResultsMessage:
          'Pencarian Anda {searchValue} tidak cocok dengan nilai apa pun.',
        cancel: 'Batal',
        searchInfo: 'Cari dalam {elements} elemen',
        selectedItems: '{items, plural, one{# terpilih} other{# terpilih}}',
        all: 'Semua',
        search: 'Cari'
      },
      bar: {
        all: 'Semua',
        selectedItems: '{items, plural, one{# terpilih} other{# terpilih}}',
        clear: 'Bersihkan'
      },
      histogram: {
        all: 'Semua',
        selectedItems: '{items} terpilih',
        clear: 'Bersihkan'
      },
      legend: {
        layerOptions: 'Opsi Layer',
        hide: 'Sembunyikan',
        show: 'Tampilkan',
        layer: 'layer',
        opacity: 'Opasitas',
        hideLayer: 'Sembunyikan layer',
        showLayer: 'Tampilkan layer',
        open: 'Buka legenda',
        close: 'Tutup',
        collapse: 'Ciutkan layer',
        expand: 'Perluas layer',
        zoomLevel: 'Tingkat Zoom',
        zoomLevelTooltip: 'Layer ini hanya terlihat pada tingkat zoom tertentu',
        lowerThan: 'lebih rendah dari',
        greaterThan: 'lebih tinggi dari',
        and: 'dan',
        zoomNote: 'Catatan: layer ini akan ditampilkan pada tingkat zoom',
        notSupported: 'bukan jenis legenda yang dikenal',
        subtitles: {
          proportion: 'Rentang radius berdasarkan',
          icon: 'Ikon berdasarkan',
          strokeColor: 'Warna garis berdasarkan',
          color: 'Warna berdasarkan'
        },
        max: 'Maks',
        min: 'Min',
        maxCategories: 'Legenda terbatas pada {n} kategori'
      },
      range: {
        clear: 'Bersihkan',
        minLimit: 'batas minimum',
        maxLimit: 'batas maksimum',
        minValue: 'nilai minimum',
        maxValue: 'nilai maksimum'
      },
      table: {
        rowsPerPage: 'Baris per halaman',
        of: '{from}–{to} dari {count}',
        moreThan: 'lebih dari'
      },
      timeSeries: {
        speed: 'Kecepatan',
        clear: 'Bersihkan'
      },
      featureSelection: {
        drawPolygonMode: 'Poligon',
        drawRectangleMode: 'Persegi panjang',
        drawPolygonByDraggingMode: 'Alat lasso',
        drawCircleFromCenterMode: 'Lingkaran',
        edit: 'Edit masker',
        clickToEdit: 'Klik pada masker untuk mengeditnya',
        clickToCreate: 'Klik pada peta untuk membuat masker',
        selectTool: 'Pilih {label}',
        selectMode: 'Pilih mode',
        chooseSelectionMode: 'Pilih mode seleksi',
        applyMask: 'Terapkan masker',
        clearMask: 'Bersihkan masker',
        remove: 'Hapus',
        polygon: 'Poligon',
        point: 'Titik',
        lineString: 'Garis'
      },
      pie: {
        clear: 'Bersihkan',
        selectedItems: '{items, plural, one{# terpilih} other{# terpilih}}',
        allSelected: 'Semua terpilih'
      },
      chartLegend: {
        next: 'Next page',
        prev: 'Previous page'
      }
    }
  }
};

export default locales;
